import CategoryResults from './CategoryResults';

export default CategoryResults;
